import { setPoleDetailsData, resetPoleDetailsData } from '../../../redux/poleDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useCallback, useEffect, useState } from 'react';
import PoleDetailsContent from './poleDetailsContent';
import { Box, CircularProgress } from '@mui/material';
import PoleDetailsHeader from './poleDetailsHeader';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const PoleDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchPoleDetails = useCallback(async () => {
        try {
            const { data, status } = await axios.get(`pole/${id}`);
            if ((status === 200 || status === 201) && data) {
                dispatch(setPoleDetailsData(data));
                setLoading(false);
            } else {
                setLoading(false);
                console.warn('Unexpected response status or empty data:', status, data);
            }
        } catch (error) {
            setLoading(false);
            console.error('Erreur lors de la récupération des informations de pole :', error);
            CustomErrorLogger(error, 'Erreur dans fetchPoleDetails');
        }
    }, [id, dispatch]);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch pole details on mount and cleanup on unmount
    useEffect(() => {
        fetchPoleDetails();
        return () => {
            dispatch(resetPoleDetailsData());
        };
    }, [fetchPoleDetails, dispatch]);

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <PoleDetailsHeader />
                    <PoleDetailsContent />
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default PoleDetails;